import React from 'react';
import SupplierDashboard from '../modules/supplier-assessment/SupplierDashboard';

export default function SupplierPortalDashboard() {
  return <SupplierDashboard />;
}
